import { fetchPost } from "~/utils/fetch";
import { EAccount } from "~/_enums/EAccount";
import { EChain } from "~/_enums/EChain";
import { ECode } from "~/_enums/ECode";

type TPayloadForEvmCompatibleAccount = {
  account: typeof EAccount.EvmCompatibleAccount;
  chain: EChain;
  address: string;
};

type TPayloadForEmailAccount = {
  account: typeof EAccount.EmailAccount;
  /** 이메일 주소 */
  address: string;
};

type TPayloadForGoogleAccount = {
  account: typeof EAccount.Google;
  oauthRedirectUrl: string;
};

type TPayloadForAppleAccount = {
  account: typeof EAccount.Apple;
  oauthRedirectUrl: string;
};

type TInputDto = {
  authRequestId: string;
  /** default: a9c98c03-858e-4dd6-ae7e-a7d20a5fdf96 */
  key: string;
  payload:
    | TPayloadForEvmCompatibleAccount
    | TPayloadForEmailAccount
    | TPayloadForGoogleAccount
    | TPayloadForAppleAccount;
};

type TDataForEvmCompatibleAccount = {
  account: typeof EAccount.EvmCompatibleAccount;
  validation: {
    message: string;
  };
};

type TDataForEmailAccount = {
  account: typeof EAccount.EmailAccount;
};

type TDataForGoogleAccount = {
  account: typeof EAccount.Google;
  authorizationUrl: string;
  scope: string[];
};

type TDataForAppleAccount = {
  account: typeof EAccount.Apple;
  authorizationUrl: string;
};

type TAuthRegisterOutputDto = {
  code: typeof ECode.Success;
  data:
    | TDataForEvmCompatibleAccount
    | TDataForEmailAccount
    | TDataForGoogleAccount
    | TDataForAppleAccount;
};

type TErrorBadRequestOutputDto = {
  code: typeof ECode.BadRequest;
  data: string;
};

type TErrMaxAttemptOutputDto = {
  code: typeof ECode.MaxAttempt;
  data: null;
};

type TOutputDto =
  | TAuthRegisterOutputDto
  | TErrorBadRequestOutputDto
  | TErrMaxAttemptOutputDto;

export const postAuthSignInRequestsRegister = ({
  authRequestId,
  ...body
}: TInputDto) =>
  fetchPost<TOutputDto>({
    url: `/auth/sign-in/requests/${authRequestId}/register`,
    body: JSON.stringify(body),
  });
